import { SxProps, Theme } from "@mui/material";

export function statusListButton(open: boolean, theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "lightgray", 
        marginTop: "15px", 
        borderRadius: open ? "5px 5px 0 0" : "5px 5px 5px 5px",
        "&:hover": { backgroundColor: "#bdbdbd" }
    };
}

export function collapsedContent(theme: Theme): SxProps<Theme> {
    return {
        border: "1px solid lightgray", 
        backgroundColor: "#f1f1f1",
        borderTop: "none", 
        borderRadius: "0 0 5px 5px",
        padding: "10px"
    };
}
